/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable indent */
/* eslint-disable react-hooks/exhaustive-deps */

import { Checkbox, Grid, makeStyles, Tooltip } from '@material-ui/core';
import { Warning as WarningIcon } from '@material-ui/icons';
import Button from 'components/Button';
import ButtonGroup from 'components/ButtonGroup';
import RefreshButton from 'components/RefreshButton';
import TableItems, {
  MenuActionItem,
  MenuActions,
  StatusIcon,
  TableCell,
  TableRow,
} from 'components/TableItems';
import Permission from 'components/ValidPermission';
import i18n from 'i18n';
import { PermissionsData, RolesEnum } from 'modules/authenticate/interfaces';
import {
  activeCheckedUSerRequest,
  activeUserInClientRequest,
  createUserInClientRequest,
  disableUserInClientRequest,
  editClientUserRequest,
  enableOrDesableRemoteProfileRequest,
  exportUsersCSVRequest,
  getAllClientsUsersRequest,
  importClientsCSVRequest,
  importUsersCSVRequest,
  inactivateAllUsersRequest,
  removeAllSelectedUserRequest,
  removeClientUserRequest,
  resetMFAUserRequest,
  sendEmailToResetPasswordRequest,
  forceResetPasswordSelectedUsersRequest,
  enableUserDeviceValidationBypassRequest,
  disableUserDeviceValidationBypassRequest,
} from 'modules/clients/actions';
import {
  ClientFields,
  ClientUsers,
  ListClientUsersDataProps,
} from 'modules/clients/interfaces';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import { formatDateValue } from 'utils/dateFormat';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import ClientsTemplate from '../Templates/Clients';
import FormImport from './FormImport';
import FormImportClient from './FormImportClient';
import FormImportCustom from './FormImportCustom';
import FormUser from './FormUser';
import TrustedDevicesList from './ListUserTrustedDevices';
import styles from './styles';
import FormDeviceValidationBypass from './FormDeviceValidationBypass';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  isLoading: boolean;
  clientUsers: ListClientUsersDataProps;
  clientSelected: ClientFields | null;
  permissions: PermissionsData | undefined;
  role?: RolesEnum;
  getAllClientsUsersRequest: (props) => void;
  modalOpen: (props: ModalFields) => void;
  removeAllSelectedUserRequest: ({ query, id, users }) => void;
  activeCheckedUSerRequest: ({ query, id, users }) => void;
  inactivateAllUsersRequest: ({ query, id, users }) => void;
  editClientUserRequest: (props) => void;
  modalClose: () => void;
  removeClientUserRequest: ({ clientUuid, userUuid, query }) => void;
  resetMFAUserRequest: ({ clientUuid, userUuid, id, query }) => void;
  enableOrDesableRemoteProfileRequest: (props) => void;
  createUserInClientRequest: ({ id, values, query }) => void;
  disableUserInClientRequest: ({ userUuid, id, query }) => void;
  activeUserInClientRequest: ({ userUuid, id, query }) => void;
  sendEmailToResetPasswordRequest: ({ id, userId, copy }) => void;
  exportUsersCSVRequest: ({ id, filename }) => void;
  importUsersCSVRequest: ({ id, values, custom }) => void;
  importClientsCSVRequest: ({ id, values }) => void;
  forceResetPasswordSelectedUsersRequest: ({
    id,
    query,
    clientUuid,
    userUuids,
    forceReset,
  }) => void;
  enableUserDeviceValidationBypassRequest: ({
    clientUuid,
    userUuid,
    values,
    getClientUsersFn,
  }) => void;
  disableUserDeviceValidationBypassRequest: ({
    clientUuid,
    userUuid,
    getClientUsersFn,
  }) => void;
}

const ListUsers = ({
  isLoading,
  clientUsers,
  clientSelected,
  permissions,
  role,
  getAllClientsUsersRequest,
  editClientUserRequest,
  activeCheckedUSerRequest,
  removeAllSelectedUserRequest,
  modalOpen,
  enableOrDesableRemoteProfileRequest,
  createUserInClientRequest,
  modalClose,
  removeClientUserRequest,
  disableUserInClientRequest,
  sendEmailToResetPasswordRequest,
  activeUserInClientRequest,
  exportUsersCSVRequest,
  resetMFAUserRequest,
  importUsersCSVRequest,
  importClientsCSVRequest,
  inactivateAllUsersRequest,
  forceResetPasswordSelectedUsersRequest,
  enableUserDeviceValidationBypassRequest,
  disableUserDeviceValidationBypassRequest,
}: Props) => {
  const classes = useStyles();

  const {
    query,
    searchValue,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const { id } = useParams<{ id: string }>();
  const [refresh, setRefresh] = React.useState(false);
  const [checks, setChecks] = React.useState<string[]>([]);
  const [selectedAll, setSelectedAll] = React.useState(false);
  const [headers] = React.useState([
    {
      key: 'first_name',
      i18n: 'NAME_KEY',
      order: true,
    },
    {
      key: 'last_name',
      i18n: 'LAST_NAME_KEY',
      order: true,
    },
    {
      key: 'email',
      i18n: 'EMAIL_KEY',
      order: true,
    },
    {
      i18n: 'USER_KEY',
      label: 'AD',
      order: false,
    },
    {
      key: 'active',
      i18n: 'STATUS_KEY',
      order: true,
      textAlignCenter: true,
      centerTitle: true,
    },
    {
      key: 'use_profile',
      i18n: 'REMOTE_PROFILE_KEY',
      order: true,
      textAlignCenter: true,
      centerTitle: true,
    },
    {
      key: 'profile_path',
      i18n: 'ADDRESS_REMOTE_PROFILE_KEY',
      order: true,
    },
    {
      key: 'security',
      i18n: 'SECURITY_KEY',
    },
    {
      key: 'user_last_access',
      i18n: 'LAST_ACCESS_SINGULAR_KEY',
      order: true,
      centerTitle: true,
    },
  ]);

  const requiredActionsPermissions: Array<keyof PermissionsData> = [
    'activate_user',
    'delete_user',
    'edit_user_details',
    'inactivate_user',
    'reset_user_mfa',
    'reset_user_password',
    'inactivate_user_reset_password_at_login',
    'activate_user_reset_password_at_login',
    'disable_user_devices',
    'list_user_devices',
  ];

  const requiredGeneralActionsPermissions: Array<keyof PermissionsData> = [
    'activate_user',
    'can_import_clients',
    'can_import_users_in_all_clients',
    'create_new_user',
    'delete_user',
    'inactivate_user',
    'list_users',
    'inactivate_user_reset_password_at_login',
    'activate_user_reset_password_at_login',
  ];

  const getClientUsers = (refresh = false) => {
    getAllClientsUsersRequest({ id, query });
    setRefresh(refresh);
  };

  React.useEffect(() => {
    getClientUsers();
  }, [getAllClientsUsersRequest, id, query]);

  const isUseProfile = () => {
    return clientSelected?.active_directory.remote_profile;
  };

  const handleCheck = (uuid: string) => {
    const findCheckId = checks.find(item => item === uuid);
    if (!findCheckId) {
      setChecks([...checks, uuid]);
    } else {
      const index = checks.indexOf(findCheckId);
      checks.splice(index, 1);
      setChecks([...checks]);
    }
  };

  const handleAllCheck = () => {
    if (!selectedAll) {
      const ids: string[] = [];
      clientUsers.results.forEach(item => ids.push(item?.user_uuid));
      setChecks(ids);
    } else {
      setChecks([]);
    }
    setSelectedAll(!selectedAll);
  };

  const handleActiveOrDisableRemoteProfile = (item: ClientUsers) => {
    modalOpen({
      title: i18n.t(
        item?.use_profile
          ? 'DISABLE_REMOTE_PROFILE_KEY'
          : 'ACTIVE_REMOTE_PROFILE_KEY'
      ),
      content: i18n.t('ACTIVE_DISABLE_PROFILE_MSG_KEY', {
        active: i18n
          .t(item?.use_profile ? 'DISABLE_KEY' : 'ENABLE_KEY')
          .toLowerCase(),
        name: `${item?.first_name} ${item?.last_name}`,
      }),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              enableOrDesableRemoteProfileRequest({
                id,
                userId: item?.user_uuid,
                active: !item?.use_profile,
                profilePath: clientSelected?.active_directory.profile_path,
                query,
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const clientHasSSO = clientSelected && clientSelected?.sso_enabled === true;

  const getButtonGroupOptions = () =>
    [
      {
        label: i18n.t('ADD_USER_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('ADD_NEW_USER_KEY'),
            content: (
              <FormUser
                role={role}
                client={clientSelected}
                onSubmit={values => {
                  createUserInClientRequest({ id, values, query });
                }}
                onCancel={modalClose}
              />
            ),
            maxWidth: 'sm',
          }),
        hidden: !permissions?.create_new_user,
      },
      {
        label: i18n.t('IMPORT_USERS_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('IMPORT_USERS_KEY'),
            content: (
              <FormImport
                onSubmit={values => {
                  importUsersCSVRequest({
                    id,
                    values,
                    custom: false,
                  });
                  modalClose();
                }}
                onCancel={modalClose}
              />
            ),
            maxWidth: 'sm',
          }),
        hidden: !!clientHasSSO || !permissions?.create_new_user,
      },
      {
        label: i18n.t('ACTIVATE_SELECTED_KEY'),
        disabled: checks.length === 0,
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_ACTIVATE_USERS_KEY'),
            content: i18n.t('ACTIVATE_SELECTED_DESCRIPTION_KEY'),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    activeCheckedUSerRequest({
                      query,
                      id,
                      users: checks,
                    });
                    setTimeout(() => {
                      setChecks([]);
                    }, 1300);
                    modalClose();
                  }}
                >
                  {i18n.t('ACTIVATE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.activate_user,
      },
      {
        label: i18n.t('INACTIVATE_SELECTED_KEY'),
        disabled: checks.length === 0,
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_INACTIVATE_USERS_KEY'),
            content: i18n.t('INACTIVATE_SELECTED_DESCRIPTION_KEY'),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    inactivateAllUsersRequest({
                      query,
                      id,
                      users: checks,
                    });
                    setTimeout(() => {
                      setChecks([]);
                    }, 1300);
                    modalClose();
                  }}
                >
                  {i18n.t('DISABLE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.inactivate_user,
      },
      {
        label: i18n.t('REMOVE_SELECTED_KEY'),
        disabled: checks.length === 0,
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_REMOVE_SELECTED_KEY'),
            content: i18n.t('REMOVE_SELECTED_DESCRIPTION_KEY'),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    removeAllSelectedUserRequest({
                      query,
                      id,
                      users: checks,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('REMOVE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.delete_user,
      },
      {
        label: i18n.t('EXPORT_CSV_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_EXPORT_CSV_KEY'),
            content: i18n.t('EXPORT_CSV_DESCRIPTION_KEY'),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    exportUsersCSVRequest({
                      id,
                      filename: `${i18n.t('LIST_USERS_EXPORT_FILENAME')}_${
                        clientSelected?.name
                      }`,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('EXPORT_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.list_users,
      },
      {
        label: i18n.t('IMPORT_CUSTOM_USERS_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('IMPORT_USUER_CUSTOM_MSG_KEY'),
            content: (
              <FormImportCustom
                onSubmit={values => {
                  importUsersCSVRequest({
                    id,
                    values,
                    custom: true,
                  });
                  modalClose();
                }}
                onCancel={modalClose}
              />
            ),
            maxWidth: 'sm',
          }),
        hidden: !!clientHasSSO || !permissions?.can_import_users_in_all_clients,
      },
      {
        label: i18n.t('IMPORT_CLIENTS_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('CLIENT_KEY'),
            content: (
              <FormImportClient
                onSubmit={values => {
                  importClientsCSVRequest({ id, values });
                  modalClose();
                }}
                onCancel={modalClose}
              />
            ),
            maxWidth: 'sm',
          }),
        hidden: !permissions?.can_import_clients,
      },
      {
        label: i18n.t('FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY'),
        disabled: checks.length === 0,
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY'),
            content: i18n.t(
              'FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_DESCRIPTION_KEY'
            ),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    forceResetPasswordSelectedUsersRequest({
                      id,
                      query,
                      forceReset: true,
                      userUuids: checks,
                      clientUuid: clientSelected?.client_uuid || '',
                    });
                    setTimeout(() => {
                      setChecks([]);
                    }, 1300);
                    modalClose();
                  }}
                >
                  {i18n.t('CONFIRM_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.activate_user_reset_password_at_login,
      },
      {
        label: i18n.t('REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY'),
        disabled: checks.length === 0,
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY'),
            content: i18n.t(
              'REMOVE_FORCE_RESET_PASSWORD_SELECTED_DESCRIPTION_KEY'
            ),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    forceResetPasswordSelectedUsersRequest({
                      id,
                      query,
                      forceReset: false,
                      userUuids: checks,
                      clientUuid: clientSelected?.client_uuid || '',
                    });
                    setTimeout(() => {
                      setChecks([]);
                    }, 1300);
                    modalClose();
                  }}
                >
                  {i18n.t('CONFIRM_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.inactivate_user_reset_password_at_login,
      },
    ].filter(option => !option.hidden);

  const handleEnableDeviceValidationBypass = (item: ClientUsers) =>
    modalOpen({
      title: i18n.t('ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY'),
      content: (
        <FormDeviceValidationBypass
          onClose={modalClose}
          onSubmit={values => {
            enableUserDeviceValidationBypassRequest({
              clientUuid: id,
              userUuid: item.user_uuid,
              values,
              getClientUsersFn: () => getClientUsers(),
            });
            modalClose();
          }}
        />
      ),
    });

  const handleDisableDeviceValidationBypass = (item: ClientUsers) =>
    modalOpen({
      title: i18n.t('DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY'),
      content: i18n.t('DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY'),
      footer: (
        <Grid>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              disableUserDeviceValidationBypassRequest({
                clientUuid: id,
                userUuid: item.user_uuid,
                getClientUsersFn: () => getClientUsers(),
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
        </Grid>
      ),
    });

  const getMenuActionItems = (item: ClientUsers) =>
    [
      {
        key: 'btn-resend-password',
        label: i18n.t('RESEND_PASSWORD_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_RESEND_PASSWORD_KEY'),
            content: item?.fictitious_email
              ? i18n.t('RESEND_PASSWORD_TO_FICTITIOUS_EMAIL_KEY')
              : i18n.t('RESEND_PASSWORD_DESCRIPTION_KEY', {
                  email: item?.email,
                }),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    sendEmailToResetPasswordRequest({
                      id,
                      userId: item?.user_uuid,
                      copy: false,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('RESEND_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: clientHasSSO || !permissions?.reset_user_password,
      },
      {
        key: 'btn-resend-password-cc',
        label: i18n.t('RESEND_PASSWORD_WITH_COPY_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_RESEND_PASSWORD_WITH_COPY_KEY'),
            content: item?.fictitious_email
              ? i18n.t('RESEND_PASSWORD_TO_FICTITIOUS_EMAIL_KEY')
              : i18n.t('RESEND_PASSWORD_WANT_COPY_DESCRIPTION_KEY', {
                  email: item?.email,
                }),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    sendEmailToResetPasswordRequest({
                      id,
                      userId: item?.user_uuid,
                      copy: true,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('RESEND_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: clientHasSSO || !permissions?.reset_user_password,
      },
      {
        key: 'btn-state-user',
        label: i18n.t('ACTIVATE_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_ACTIVATE_USERS_KEY'),
            content: i18n.t('ACTIVE_USER_KEY', {
              id: `${item?.first_name} ${item?.last_name}`,
            }),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    activeUserInClientRequest({
                      userUuid: item?.user_uuid,
                      id,
                      query,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('ACTIVATE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: item?.active || !permissions?.activate_user,
      },
      {
        key: 'btn-state-user',
        label: i18n.t('DISABLE_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_DISABLE_USER_KEY'),
            content: i18n.t('DISABLE_USER_DESCRIPTION_KEY'),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    disableUserInClientRequest({
                      userUuid: item?.user_uuid,
                      id,
                      query,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('DISABLE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !item?.active || !permissions?.inactivate_user,
      },
      {
        key: 'btn-edit-user',
        label: i18n.t('EDIT_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('EDIT_USER_KEY'),
            content: (
              <FormUser
                role={role}
                isEdit
                client={clientSelected}
                defaultValues={item}
                onSubmit={values => {
                  editClientUserRequest({
                    clientUuid: id,
                    userUuid: item?.user_uuid,
                    values,
                    query,
                  });
                  modalClose();
                }}
                onCancel={modalClose}
              />
            ),
            maxWidth: 'sm',
          }),
        hidden: !permissions?.edit_user_details,
      },
      {
        key: 'btn-remove-user',
        label: i18n.t('REMOVE_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('WANT_REMOVE_USER_KEY', {
              name: `${item?.first_name} ${item?.last_name}`,
            }),
            content: i18n.t('REMOVE_USER_DESCRIPTION_KEY'),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    removeClientUserRequest({
                      clientUuid: id,
                      userUuid: item?.user_uuid,
                      query,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('REMOVE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.delete_user,
      },
      {
        key: 'reset_user_mfa',
        label: i18n.t('MFA_RESET_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('CLIENTS_PAGE.MFA_USER_RESET_TITLE_KEY'),
            content: i18n.t('CLIENTS_PAGE.MFA_USER_RESET_MSG_KEY', {
              name: `${item?.first_name} ${item?.last_name}`,
            }),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    resetMFAUserRequest({
                      clientUuid: id,
                      userUuid: item?.user_uuid,
                      id,
                      query,
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('MFA_RESET_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: clientHasSSO || !permissions?.reset_user_mfa,
      },
      {
        key: 'toggle-remote-profile',
        label: i18n.t(
          item?.use_profile
            ? 'DISABLE_REMOTE_PROFILE_KEY'
            : 'ACTIVE_REMOTE_PROFILE_KEY'
        ),
        onClick: () => handleActiveOrDisableRemoteProfile(item),
        hidden: !isUseProfile() || !permissions?.edit_user_details,
      },
      {
        key: 'btn-force-reset-password-require',
        label: i18n.t(
          item?.reset_password_at_login
            ? 'REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY'
            : 'FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY'
        ),
        onClick: () =>
          modalOpen({
            title: i18n.t(
              item?.reset_password_at_login
                ? 'REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY'
                : 'FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY'
            ),
            content: i18n.t(
              item?.reset_password_at_login
                ? 'REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY'
                : 'FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY',
              {
                name: `${item?.first_name} ${item?.last_name}`,
              }
            ),
            footer: (
              <Grid>
                <Button
                  submitButton
                  id="submit-button"
                  onClick={() => {
                    forceResetPasswordSelectedUsersRequest({
                      id,
                      query,
                      userUuids: [item?.user_uuid],
                      forceReset: !item?.reset_password_at_login,
                      clientUuid: clientSelected?.client_uuid || '',
                    });
                    modalClose();
                  }}
                >
                  {i18n.t('CONFIRM_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: item?.reset_password_at_login
          ? !permissions?.inactivate_user_reset_password_at_login
          : !permissions?.activate_user_reset_password_at_login,
      },
      {
        key: 'trusted-devices',
        label: i18n.t('TRUSTED_DEVICES_KEY'),
        onClick: () =>
          modalOpen({
            title: i18n.t('TRUSTED_DEVICES_KEY'),
            content: <TrustedDevicesList userUuid={item?.user_uuid} />,
            maxWidth: 'lg',
            fullWidth: true,
            footer: (
              <Grid>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={modalClose}
                >
                  {i18n.t('CLOSE_KEY')}
                </Button>
              </Grid>
            ),
          }),
        hidden: !permissions?.list_user_devices,
        style: {
          borderTop: '1px solid #EEE',
        },
      },
      {
        key: 'enable-device-validation-bypass',
        label: i18n.t('ENABLE_DEVICE_VALIDATION_BYPASS_KEY'),
        onClick: () => handleEnableDeviceValidationBypass(item),
        hidden:
          !permissions?.enable_device_validation_bypass ||
          !!item.device_validation_bypass,
      },
      {
        key: 'disable-device-validation-bypass',
        label: i18n.t('DISABLE_DEVICE_VALIDATION_BYPASS_KEY'),
        onClick: () => handleDisableDeviceValidationBypass(item),
        hidden:
          !permissions?.disable_device_validation_bypass ||
          !item.device_validation_bypass,
      },
    ].filter(action => !action?.hidden);

  return (
    <ClientsTemplate
      current="users"
      title={i18n.t('CLIENTS_PAGE.LIST_USERS_TITLE_KEY')}
      subtitle={i18n.t('CLIENTS_PAGE.LIST_USERS_SUBTITLE_KEY')}
      breadcrumbs={[
        {
          name: i18n.t('CLIENT_KEY'),
          link: '/clients',
        },
        {
          name: i18n.t('USERS_KEY'),
        },
      ]}
      button={
        <Grid item xs={12} sm={4} md={3} className={classes.buttonsHeader}>
          <RefreshButton
            id="btn-refresh"
            onClick={() => getClientUsers(true)}
            animate={isLoading}
            disabled={isLoading}
          />

          <Permission value={requiredGeneralActionsPermissions}>
            <ButtonGroup
              style={{ marginLeft: 16 }}
              label={i18n.t('GENERAL_ACTIONS_KEY')}
              options={getButtonGroupOptions()}
            />
          </Permission>
        </Grid>
      }
    >
      <Grid container className={classes.tableContainer}>
        <SearchBar
          id="search-users"
          isLoading={isLoading}
          searchValue={searchValue}
          handleSearch={handleSearch}
          setSearchValue={setSearchValue}
        />
        <TableItems
          header={
            <>
              <TableCell className={classes.checkboxCell}>
                <Checkbox
                  onClick={handleAllCheck}
                  id="select-all-clients-users"
                />
              </TableCell>
              {headers.slice(0, 5).map(item => (
                <TableCell
                  textAlignCenter={item?.textAlignCenter}
                  centerTitle={item?.centerTitle}
                  key={item?.key}
                  order={item?.order}
                  handleOrder={() =>
                    item?.order ? handleOrder(item?.key || '') : null
                  }
                >
                  {`${i18n.t(item?.i18n)} ${item?.label ? item?.label : ''}`}
                </TableCell>
              ))}
              {isUseProfile() && (
                <>
                  {headers.slice(5, 7).map(item => (
                    <TableCell
                      textAlignCenter={item?.textAlignCenter}
                      centerTitle={item?.centerTitle}
                      key={item?.key}
                      className={classes.header}
                      order={item?.order}
                      handleOrder={() =>
                        item?.order ? handleOrder(item?.key || '') : null
                      }
                    >
                      {`${i18n.t(item?.i18n)} ${
                        item?.label ? item?.label : ''
                      }`}
                    </TableCell>
                  ))}
                </>
              )}
              {headers.slice(7).map(item => (
                <TableCell
                  textAlignCenter={item?.textAlignCenter}
                  centerTitle={item?.centerTitle}
                  className={classes.header}
                  key={item?.key}
                  order={item?.order}
                  handleOrder={() =>
                    item?.order ? handleOrder(item?.key || '') : null
                  }
                >
                  {`${i18n.t(item?.i18n)} ${item?.label ? item?.label : ''}`}
                </TableCell>
              ))}
              <Permission value={requiredActionsPermissions}>
                <TableCell centerTitle>{i18n.t('ACTIONS_KEY')}</TableCell>
              </Permission>
            </>
          }
          renderItems={(item: ClientUsers, index) => (
            <TableRow key={item?.user_uuid}>
              <TableCell className={classes.checkboxCell}>
                <Checkbox
                  onClick={() => handleCheck(item?.user_uuid)}
                  id="select-clients-users"
                  checked={!!checks.find(check => check === item?.user_uuid)}
                />
              </TableCell>
              <TableCell>{item?.first_name}</TableCell>
              <TableCell>{item?.last_name}</TableCell>
              <TableCell copyable ellipsis maxLength={14}>
                {item?.email}
              </TableCell>
              <TableCell ellipsis copyable maxLength={8}>
                {item?.partner?.active_directory?.username || ''}
              </TableCell>
              <TableCell
                className={classes.wrapStatus}
                tooltip={i18n.t(item?.active ? 'ACTIVE_KEY' : 'INACTIVE_KEY')}
                align="center"
              >
                <StatusIcon status={item?.active ? 'success' : 'inactive'} />
              </TableCell>
              {isUseProfile() && (
                <>
                  <TableCell centerTitle textAlignCenter>
                    {i18n.t(item?.use_profile ? 'ACTIVE_KEY' : 'INACTIVE_KEY')}
                  </TableCell>
                  <TableCell>
                    {item?.profile_path ? item?.profile_path : 'N/A'}
                  </TableCell>
                </>
              )}
              <TableCell>
                <Grid container justify="flex-start" spacing={1}>
                  <Grid item>
                    <Tooltip
                      arrow
                      title={
                        item?.mfa_configured
                          ? i18n.t('MFA_CONFIGURED_TOOLTIP')
                          : i18n.t('MFA_NOT_CONFIGURED_TOOLTIP')
                      }
                    >
                      {item?.mfa_configured ? (
                        <img
                          src="/images/mfaConfigEnable.svg"
                          alt="Logo"
                          height={20}
                        />
                      ) : (
                        <img
                          src="/images/mfaConfigDisable.svg"
                          alt="Logo"
                          height={20}
                        />
                      )}
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip
                      arrow
                      title={
                        item?.mfa_active
                          ? i18n.t('MFA_ACTIVE_TOOLTIP')
                          : i18n.t('MFA_INACTIVE_TOOLTIP')
                      }
                    >
                      {item?.mfa_active ? (
                        <img
                          src="/images/mfaEnable.svg"
                          alt="Logo"
                          height={20}
                        />
                      ) : (
                        <img
                          src="/images/mfaDisable.svg"
                          alt="Logo"
                          height={20}
                        />
                      )}
                    </Tooltip>
                  </Grid>

                  <Grid item>
                    <Tooltip
                      arrow
                      title={
                        item?.has_safe_device_enabled
                          ? i18n.t('SAFE_DEVICE_ENABLED_TOOLTIP')
                          : i18n.t('SAFE_DEVICE_DISABLED_TOOLTIP')
                      }
                    >
                      {item?.has_safe_device_enabled ? (
                        <img
                          src="/images/safeDeviceEnable.svg"
                          alt="Logo"
                          height={20}
                        />
                      ) : (
                        <img
                          src="/images/safeDeviceDisable.svg"
                          alt="Logo"
                          height={20}
                        />
                      )}
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    {item?.device_validation_bypass ? (
                      <Tooltip
                        arrow
                        title={i18n.t('DEVICE_VALIDATION_BYPASS_ENABLED')}
                      >
                        <img
                          src="/images/bypassEnable.svg"
                          alt="Logo"
                          height={20}
                        />
                      </Tooltip>
                    ) : null}
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell
                centerTitle
                textAlignCenter
                className={classes.dateField}
              >
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <div>{formatDateValue(item?.user_last_access)}</div>
                  {item?.reset_password_at_login && (
                    <Tooltip
                      placement="top"
                      arrow
                      title={i18n.t('PASSWORD_CHANGE_REQUIRED_KEY')}
                    >
                      <WarningIcon className={classes.warningIcon} />
                    </Tooltip>
                  )}
                </Grid>
              </TableCell>
              <Permission value={requiredActionsPermissions}>
                <TableCell textAlignCenter>
                  <MenuActions id={`btn-options-users-${index}`}>
                    {getMenuActionItems(item)?.length > 0 ? (
                      getMenuActionItems(item)?.map(action => (
                        <MenuActionItem
                          key={action?.key}
                          id={action?.key}
                          style={action?.style}
                          onClick={action?.onClick}
                        >
                          {action?.label}
                        </MenuActionItem>
                      ))
                    ) : (
                      <MenuActionItem>
                        {i18n.t('NO_ACTIONS_AVAILABLE_KEY')}
                      </MenuActionItem>
                    )}
                  </MenuActions>
                </TableCell>
              </Permission>
            </TableRow>
          )}
          data={clientUsers}
          isLoading={!refresh && isLoading}
          onChangePage={handlePageChange}
          onChangeLimit={handleLimitChange}
          notFoundText={i18n.t('CLIENTS_PAGE.NO_USERS_KEY')}
          colCount={11}
        />
      </Grid>
    </ClientsTemplate>
  );
};

const mapStateToProps = ({
  authenticate: { data },
  clients: { isLoading, clientUsers, clientSelected },
  partners: { partnerDetails },
}: ApplicationState) => ({
  isLoading,
  clientUsers,
  clientSelected,
  partnerDetails,
  permissions: data?.permissions,
  role: data?.role,
});

export default connect(mapStateToProps, {
  getAllClientsUsersRequest,
  editClientUserRequest,
  modalOpen,
  modalClose,
  removeClientUserRequest,
  createUserInClientRequest,
  disableUserInClientRequest,
  sendEmailToResetPasswordRequest,
  activeUserInClientRequest,
  exportUsersCSVRequest,
  resetMFAUserRequest,
  enableOrDesableRemoteProfileRequest,
  removeAllSelectedUserRequest,
  importUsersCSVRequest,
  importClientsCSVRequest,
  activeCheckedUSerRequest,
  inactivateAllUsersRequest,
  forceResetPasswordSelectedUsersRequest,
  enableUserDeviceValidationBypassRequest,
  disableUserDeviceValidationBypassRequest,
})(ListUsers);
